import React from 'react';

import Hero from '../components/Hero';
import AnchorNav from '../components/AnchorNav';
import IndustryList from '../components/IndustryList';
import Section from '../components/Section';

const CustomersIndexTemplate = ({ pageContext: { page, entries } }) => (
  <Section>
    <Hero {...page} />

    <AnchorNav items={entries} />
    <IndustryList entries={entries} {...page} />
  </Section>
);

export default CustomersIndexTemplate;
